import { FC } from 'react';
import { Box, Modal, Typography, Button, Divider } from '@mui/material';
import parser from 'html-react-parser';

interface IProps {
	open: boolean;
	onClose: () => void;
	title: string;
	description: string;
	onSubmit?: () => void;
	submitText?: string;
	closeText?: string;
}

const HelperModal: FC<IProps> = ({
	open,
	onClose,
	title,
	description,
	onSubmit,
	submitText = 'Submit',
	closeText = 'Close',
}) => (
	<Modal
		open={open}
		onClose={onClose}
		aria-labelledby='helper-modal-modal-title'
		aria-describedby='helper-modal-modal-description'
	>
		<Box
			sx={(theme) => ({
				position: 'absolute',
				top: '50%',
				left: '50%',
				borderRadius: 4,
				transform: 'translate(-50%, -50%)',
				width: '25%',
				bgcolor: 'background.paper',
				boxShadow: 24,
				overflow: 'hidden',
				border: `2px solid ${theme.palette.grey[300]}`,
				[theme.breakpoints.down('md')]: {
					width: '90%',
				},
			})}
		>
			<Box
				sx={{
					py: 1,
					px: 2,
				}}
			>
				<Typography sx={{ color: 'primary.main' }} id='helper-modal-modal-title' variant='h6' component='h2'>
					{title}
				</Typography>
			</Box>
			<Divider />
			<Box
				sx={{
					py: 2,
					px: 2,
					overflowY: 'auto',
					maxHeight: '500px',
					overflowX: 'hidden',
				}}
			>
				<Typography
					id='helper-modal-modal-description'
					sx={{
						'& a': {
							overflowWrap: 'break-word',
						},
						'& .sub-paragraph': {
							display: 'inline-block',
							marginBottom: '1em',
						},
					}}
				>
					{parser(description)}
				</Typography>
			</Box>
			<Divider />
			<Box
				sx={{
					py: 1,
					px: 2,
					display: 'flex',
					flexDirection: 'row-reverse',
				}}
			>
				{onSubmit && (
					<Button variant='contained' color='primary' onClick={onSubmit} sx={{ ml: 2 }}>
						{submitText}
					</Button>
				)}
				<Button variant='contained' color={onSubmit ? 'inherit' : 'primary'} onClick={onClose}>
					{closeText}
				</Button>
			</Box>
		</Box>
	</Modal>
);

export default HelperModal;
